export default __webpack_public_path__ + "static/media/map-icon-yellow1.3986ef0e.svg";